<script setup lang="ts">
import { TabsList as RadixTabsList } from 'radix-vue'
import { inject, computed, type Ref } from 'vue'

interface TabsStyles {
  line: {
    list: string
    trigger: string[]
  }
  solid: {
    list: string
    trigger: string[]
  }
}

type TabVariant = keyof TabsStyles

const defaultStyles: TabsStyles = {
  line: {
    list: 'flex items-center justify-start border-b border-gray-200 dark:border-gray-800',
    trigger: [],
  },
  solid: {
    list: 'inline-flex items-center justify-center rounded-md p-1 bg-gray-100 dark:bg-gray-900',
    trigger: [],
  },
}

const props = defineProps<{
  class?: string
}>()

const variant = inject<Ref<TabVariant>>(
  'tabs-variant',
  computed(() => 'line'),
)
const styles = inject<Ref<TabsStyles>>(
  'tabs-styles',
  computed(() => defaultStyles),
)

const listStyles = computed(() => styles.value[variant.value].list)
</script>

<template>
  <RadixTabsList :class="[listStyles, props.class]">
    <slot />
  </RadixTabsList>
</template>
